import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, ArrowLeft, CheckCircle } from 'lucide-react';

const CookiePolicyPage = () => {
  return (
    <div data-testid="cookie-policy-page" className="min-h-screen bg-[#FAFAF8]">
      {/* Header */}
      <section className="bg-white py-12 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <Link to="/" className="inline-flex items-center text-[#4CAF50] hover:text-[#43A047] mb-6">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Grįžti į pradžią
          </Link>
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-[#FFF3E0] rounded-2xl flex items-center justify-center">
              <Cookie className="w-8 h-8 text-[#FF9F43]" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-['Poppins'] font-bold text-[#2D3748]">
                Slapukų politika
              </h1>
              <p className="text-[#718096]">Paskutinis atnaujinimas: 2025 m. sausio mėn.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-100 prose prose-slate max-w-none">
            
            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748] mt-0">1. Kas yra slapukai?</h2>
            <p className="text-[#718096] leading-relaxed">
              Slapukai (angl. cookies) – tai maži tekstiniai failai, kuriuos svetainė išsaugo 
              jūsų įrenginyje (kompiuteryje, telefone, planšetėje), kai apsilankote svetainėje. 
              Slapukai padeda svetainei „atsiminti" jūsų veiksmus ir nustatymus, kad nereikėtų 
              jų iš naujo įvesti kiekvieną kartą.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">2. Kodėl naudojame slapukus?</h2>
            <p className="text-[#718096] leading-relaxed">Slapukus naudojame šiais tikslais:</p>
            <ul className="text-[#718096] space-y-2">
              <li>Užtikrinti svetainės veikimą ir saugumą</li>
              <li>Išsaugoti jūsų krepšelio turinį</li>
              <li>Prisiminti jūsų prisijungimo būseną</li>
              <li>Analizuoti svetainės lankomumą ir tobulinti ją</li>
              <li>Pagerinti jūsų naudotojo patirtį</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">3. Slapukų tipai</h2>
            
            <div className="bg-[#E8F5E9] rounded-2xl p-6 my-6">
              <h3 className="text-lg font-semibold text-[#2D3748] flex items-center mb-3">
                <CheckCircle className="w-5 h-5 text-[#4CAF50] mr-2" />
                Būtinieji slapukai
              </h3>
              <p className="text-[#718096] text-sm mb-0">
                Šie slapukai būtini svetainės veikimui. Be jų svetainė neveiks tinkamai. 
                Jie išsaugo jūsų sesiją, krepšelio turinį ir prisijungimo būseną.
              </p>
            </div>

            <div className="bg-[#E3F2FD] rounded-2xl p-6 my-6">
              <h3 className="text-lg font-semibold text-[#2D3748] flex items-center mb-3">
                <CheckCircle className="w-5 h-5 text-[#5B9BD5] mr-2" />
                Analitiniai slapukai
              </h3>
              <p className="text-[#718096] text-sm mb-0">
                Šie slapukai padeda mums suprasti, kaip lankytojai naudojasi svetaine. 
                Informacija naudojama svetainės tobulinimui. Duomenys anoniminiai.
              </p>
            </div>

            <div className="bg-[#FFF3E0] rounded-2xl p-6 my-6">
              <h3 className="text-lg font-semibold text-[#2D3748] flex items-center mb-3">
                <CheckCircle className="w-5 h-5 text-[#FF9F43] mr-2" />
                Funkciniai slapukai
              </h3>
              <p className="text-[#718096] text-sm mb-0">
                Šie slapukai leidžia svetainei atsiminti jūsų pasirinkimus 
                (pvz., kalbą, regioną) ir teikti patobulintas funkcijas.
              </p>
            </div>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">4. Naudojami slapukai</h2>
            
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-[#718096] border-collapse">
                <thead>
                  <tr className="bg-[#FAFAF8]">
                    <th className="text-left p-3 font-semibold text-[#2D3748] border border-slate-200">Pavadinimas</th>
                    <th className="text-left p-3 font-semibold text-[#2D3748] border border-slate-200">Tipas</th>
                    <th className="text-left p-3 font-semibold text-[#2D3748] border border-slate-200">Trukmė</th>
                    <th className="text-left p-3 font-semibold text-[#2D3748] border border-slate-200">Paskirtis</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-3 border border-slate-200">session_id</td>
                    <td className="p-3 border border-slate-200">Būtinas</td>
                    <td className="p-3 border border-slate-200">Sesija</td>
                    <td className="p-3 border border-slate-200">Vartotojo sesijos identifikavimas</td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-slate-200">cart</td>
                    <td className="p-3 border border-slate-200">Būtinas</td>
                    <td className="p-3 border border-slate-200">7 dienos</td>
                    <td className="p-3 border border-slate-200">Krepšelio turinio išsaugojimas</td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-slate-200">auth_token</td>
                    <td className="p-3 border border-slate-200">Būtinas</td>
                    <td className="p-3 border border-slate-200">24 val.</td>
                    <td className="p-3 border border-slate-200">Prisijungimo autentifikacija</td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-slate-200">cookie_consent</td>
                    <td className="p-3 border border-slate-200">Būtinas</td>
                    <td className="p-3 border border-slate-200">1 metai</td>
                    <td className="p-3 border border-slate-200">Slapukų sutikimo įrašymas</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">5. Trečiųjų šalių slapukai</h2>
            <p className="text-[#718096] leading-relaxed">
              Mūsų svetainėje gali būti naudojami trečiųjų šalių slapukai:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>Paysera:</strong> mokėjimų apdorojimui</li>
              <li><strong>Google Analytics:</strong> svetainės lankomumo analizei (jei įjungta)</li>
            </ul>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">6. Kaip valdyti slapukus?</h2>
            <p className="text-[#718096] leading-relaxed">
              Galite valdyti ir ištrinti slapukus savo naršyklės nustatymuose:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li><strong>Chrome:</strong> Nustatymai → Privatumas ir sauga → Slapukai</li>
              <li><strong>Firefox:</strong> Nustatymai → Privatumas ir sauga → Slapukai</li>
              <li><strong>Safari:</strong> Nustatymai → Privatumas → Slapukai</li>
              <li><strong>Edge:</strong> Nustatymai → Slapukai ir svetainės leidimai</li>
            </ul>
            <p className="text-[#718096] leading-relaxed">
              <strong>Pastaba:</strong> Išjungus būtinuosius slapukus, svetainė gali veikti netinkamai.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">7. Sutikimas</h2>
            <p className="text-[#718096] leading-relaxed">
              Pirmą kartą apsilankius svetainėje, pamatysite slapukų pranešimą. Galite:
            </p>
            <ul className="text-[#718096] space-y-2">
              <li>Sutikti su visais slapukais</li>
              <li>Priimti tik būtinuosius slapukus</li>
              <li>Tvarkyti nustatymus detaliau</li>
            </ul>
            <p className="text-[#718096] leading-relaxed">
              Sutikimą galite bet kada atšaukti išvalydami slapukus naršyklėje.
            </p>

            <h2 className="text-2xl font-['Poppins'] font-semibold text-[#2D3748]">8. Kontaktai</h2>
            <p className="text-[#718096] leading-relaxed">
              Klausimai dėl slapukų? Susisiekite: <a href="mailto:info@tavoemocijos.lt" className="text-[#4CAF50] hover:underline">info@tavoemocijos.lt</a>
            </p>

          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
